var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "we-select-person"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("点击打开 选人组件")])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };